/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { GetElectricityConsumptionSummaryV1200ResponseFromJSON, GetElectricityConsumptionV1200ResponseFromJSON, GetOverduePaymentAmountV1200ResponseFromJSON, } from '../models/index';
/**
 *
 */
export class ReportApi extends runtime.BaseAPI {
    /**
     * Get Electricity Consumption Summary
     * Get Electricity Consumption Summary
     */
    async getElectricityConsumptionSummaryV1Raw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['customerIdIn'] != null) {
            queryParameters['customer_id__in'] = requestParameters['customerIdIn'];
        }
        if (requestParameters['fromDate'] != null) {
            queryParameters['from_date'] = requestParameters['fromDate'].toISOString().substring(0, 10);
        }
        if (requestParameters['toDate'] != null) {
            queryParameters['to_date'] = requestParameters['toDate'].toISOString().substring(0, 10);
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("firebase", []);
        }
        const response = await this.request({
            path: `/v1/reports/electricity-consumption-summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetElectricityConsumptionSummaryV1200ResponseFromJSON(jsonValue));
    }
    /**
     * Get Electricity Consumption Summary
     * Get Electricity Consumption Summary
     */
    async getElectricityConsumptionSummaryV1(requestParameters = {}, initOverrides) {
        const response = await this.getElectricityConsumptionSummaryV1Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Electricity Consumption
     * Get Electricity Consumption
     */
    async getElectricityConsumptionV1Raw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['customerIdIn'] != null) {
            queryParameters['customer_id__in'] = requestParameters['customerIdIn'];
        }
        if (requestParameters['fromDate'] != null) {
            queryParameters['from_date'] = requestParameters['fromDate'].toISOString().substring(0, 10);
        }
        if (requestParameters['toDate'] != null) {
            queryParameters['to_date'] = requestParameters['toDate'].toISOString().substring(0, 10);
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("firebase", []);
        }
        const response = await this.request({
            path: `/v1/reports/electricity-consumption`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetElectricityConsumptionV1200ResponseFromJSON(jsonValue));
    }
    /**
     * Get Electricity Consumption
     * Get Electricity Consumption
     */
    async getElectricityConsumptionV1(requestParameters = {}, initOverrides) {
        const response = await this.getElectricityConsumptionV1Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Overdue Payment Amount
     * Get Overdue Payment Amount
     */
    async getOverduePaymentAmountV1Raw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['customerIdIn'] != null) {
            queryParameters['customer_id__in'] = requestParameters['customerIdIn'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("firebase", []);
        }
        const response = await this.request({
            path: `/v1/reports/overdue-payment-amount`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetOverduePaymentAmountV1200ResponseFromJSON(jsonValue));
    }
    /**
     * Get Overdue Payment Amount
     * Get Overdue Payment Amount
     */
    async getOverduePaymentAmountV1(requestParameters = {}, initOverrides) {
        const response = await this.getOverduePaymentAmountV1Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Total Amount Due
     * Get Total Amount Due
     */
    async getTotalAmountDueV1Raw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['customerIdIn'] != null) {
            queryParameters['customer_id__in'] = requestParameters['customerIdIn'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("firebase", []);
        }
        const response = await this.request({
            path: `/v1/reports/total-amount-due`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetOverduePaymentAmountV1200ResponseFromJSON(jsonValue));
    }
    /**
     * Get Total Amount Due
     * Get Total Amount Due
     */
    async getTotalAmountDueV1(requestParameters = {}, initOverrides) {
        const response = await this.getTotalAmountDueV1Raw(requestParameters, initOverrides);
        return await response.value();
    }
}
